// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1mn3i","buttons":"PendingPaymentAlert_buttons__1xqEM"};